import {
  DimensionTranslateType,
  DimensionType,
} from 'core/api/dto/BuffetReportDto'
import { IPlanMenuControlDimensionDto } from 'core/api/dto/PlanMenuControlDto'

import React from 'react'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import { getTimeFromMins } from 'utils/formatDate'

export const FrozeDetailInfo = ({
  dimensionItem,
}: {
  dimensionItem: IPlanMenuControlDimensionDto
}) => {
  const { t } = useTranslation()
  return (
    <div className="detail-wrap">
      <div className="detail-header">
        <span>{t('Факт')}</span>
        <span>{t('Эталонность')}</span>
      </div>
      <FrozeDetailCommonInfo
        type={dimensionItem.dimensionType}
        dimensionDatetime={dimensionItem.dimensionDatetime}
        implementationTime={dimensionItem.implementationTime}
        dishImplementationTime={dimensionItem.dishImplementationTime || 0}
        implementationTimeExceeded={
          dimensionItem.implementationTimeExceeded || 0
        }
      />
      <div className="line-h" />
      <FrozeDetailWeightInfo
        weight={dimensionItem.weightTotal || 0}
        dishStandardWeight={dimensionItem.dishStandardWeight || 0}
        milletWeight={dimensionItem.weightOfMillet || 0}
        quantity={dimensionItem.weightOfDish || 0}
      />
      <div className="line-h" />
      <FrozeDetailTempInfo
        temperature={dimensionItem.temperature}
        tempMin={dimensionItem.dishTempMin}
        tempMax={dimensionItem.dishTempMax}
        tempChecker={dimensionItem.tempChecker}
      />
      <div className="line-h" />
    </div>
  )
}
interface IFrozeDetailTempInfoProps {
  temperature: number | null
  tempMin: number
  tempMax: number
  tempChecker: number
}

const FrozeDetailTempInfo = ({
  temperature,
  tempMin,
  tempMax,
  tempChecker,
}: IFrozeDetailTempInfoProps) => {
  const { t } = useTranslation()
  return (
    <React.Fragment>
      <div className="detail-row">
        <div className="detail-item">
          <i className="an-ico an-ico-temp" />
          <span>{t('Температура')}</span>
          <div className="dotes" />
          <span>
            <b>
              {temperature || temperature === 0 ? temperature + '°C' : '---'}
            </b>
          </span>
        </div>
        <div className="detail-item">
          <i className="an-ico an-ico-temp" />
          <span>{t('Температура')}</span>
          <div className="dotes" />
          <span>
            <b>{tempMin}°C</b>
            <b> - </b>
            <b>{tempMax}°C</b>
          </span>
        </div>
      </div>
      {tempChecker && (
        <div className="detail-total">
          <div className="close-block">
            <i className="an-ico an-ico-close" />
          </div>
          <span>
            {t(
              tempChecker > 0
                ? 'Температура превышена'
                : 'Температура ниже нормы',
            )}
          </span>
          <div className="dotes" />
          <span>
            <b>{tempChecker.toFixed(0)}°C</b>
          </span>
        </div>
      )}
    </React.Fragment>
  )
}
interface IFrozeDetailCommonInfoProps {
  type: DimensionType
  dimensionDatetime: string
  implementationTime: number
  dishImplementationTime: number
  implementationTimeExceeded: number
}

const FrozeDetailCommonInfo = ({
  type,
  dimensionDatetime,
  implementationTime,
  dishImplementationTime,
  implementationTimeExceeded,
}: IFrozeDetailCommonInfoProps) => {
  const { t } = useTranslation()
  return (
    <React.Fragment>
      <div className="detail-row">
        <div className="detail-item">
          <i className="an-ico an-ico-aim-2" />
          <span>{t('Тип замера')}:</span>
          <div className="dotes" />
          <span>
            <b>{t(DimensionTranslateType[type])}</b>
          </span>
        </div>
        <div className="detail-item" />
      </div>
      <div className="detail-row">
        <div className="detail-item">
          <i className="an-ico an-ico-calendar" />
          <span>{t('Дата замера')}:</span>
          <div className="dotes" />
          <span>
            <b>{moment.parseZone(dimensionDatetime).format('DD/MM/YYYY')}</b>
          </span>
        </div>
        <div className="detail-item" />
      </div>
      <div className="detail-row">
        <div className="detail-item">
          <i className="an-ico an-ico-watch" />
          <span>{t('Время замера')}: </span>
          <div className="dotes" />
          <span>
            <b>{moment.parseZone(dimensionDatetime).format('HH:mm')}</b>
          </span>
        </div>
      </div>
      <div className="detail-row">
        <div className="detail-item">
          <i className="an-ico an-ico-watch" />
          <span>{t('Время реализации')}: </span>
          <div className="dotes" />
          <span>
            <b>{getTimeFromMins(implementationTime)}</b>
          </span>
        </div>
        <div className="detail-item">
          <i className="an-ico an-ico-watch" />
          <span>{t('Время реализации')}: </span>
          <div className="dotes" />
          <span>
            <b>{getTimeFromMins(dishImplementationTime)}</b>
          </span>
        </div>
      </div>
      {!!implementationTimeExceeded && (
        <div className="detail-total">
          <div className="close-block">
            <i className="an-ico an-ico-close" />
          </div>
          <span>{t('Время превышено')}</span>
          <div className="dotes" />
          <span>
            <b>{getTimeFromMins(implementationTimeExceeded)}</b>
          </span>
        </div>
      )}
    </React.Fragment>
  )
}
interface IFrozeDetailWeightInfoProps {
  quantity: number
  weight: number
  milletWeight: number
  dishStandardWeight: number
}

const FrozeDetailWeightInfo = ({
  weight,
  quantity,
  milletWeight,
  dishStandardWeight,
}: IFrozeDetailWeightInfoProps) => {
  const { t } = useTranslation()
  return (
    <React.Fragment>
      <div className="detail-row">
        <div className="detail-item">
          <i className="an-ico an-ico-scales" />
          <span>{t('Вес без тары')}</span>
          <div className="dotes" />
          <span>
            <b>
              {quantity.toFixed(3).toString().replace(/[.]/g, ',')} {t('кг')}
            </b>
          </span>
        </div>
        <div className="detail-item" />
      </div>
      <div className="detail-row">
        <div className="detail-item">
          <i className="an-ico an-ico-scales" />
          <span>{t('Вес тары')}</span>
          <div className="dotes" />
          <span>
            <b>
              {milletWeight.toFixed(3).toString().replace(/[.]/g, ',')}{' '}
              {t('кг')}
            </b>
          </span>
        </div>
        <div className="detail-item">
          <i className="an-ico an-ico-scales" />
          <span>{t('Вес')}</span>
          <div className="dotes" />
          <span>
            <b>
              {dishStandardWeight.toFixed(3).toString().replace(/[.]/g, ',')}{' '}
              {t('кг')}
            </b>
          </span>
        </div>
      </div>
      <div className="detail-row">
        <div className="detail-item">
          <i className="an-ico an-ico-scales" />
          <span>{t('Общий вес')}</span>
          <div className="dotes" />
          <span>
            <b>
              {weight.toFixed(3).toString().replace(/[.]/g, ',')} {t('кг')}
            </b>
          </span>
        </div>
        <div className="detail-item" />
      </div>
    </React.Fragment>
  )
}
